import Vue from 'vue'
import VueRouter from 'vue-router'
import { default as OneRoutes } from './route_2023_sh'
import { default as TwoRoutes } from './route_2024'
import global from '@/Global.vue'
import {id_arr} from "@/utils/api.js"

Vue.use(VueRouter)

const routes = [
    // 重定向（涉及年份路径的重定向，首页用'redirect'代'alias'，其他页面用下面router.beforeEach中的方法代'redirect'）
    { path: '/', redirect: '/2023' },
    { path: '/2023', redirect: '/2023sh/' },
    ...OneRoutes, // 2023 广东深圳 -> 江苏南京
    ...TwoRoutes, // 2024 江苏南京
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            if (from.meta.keepAlive) {
                from.meta.savedPosition = document.body.scrollTop
            }
            return {
                x: 0,
                y: to.meta.savedPosition || 0
            }
        }
    }
})

router.beforeEach((to, from, next) => {
  // console.log(to);
  // console.log(to,from);
  console.log(global.year);
  if (to.path.split('/').length < 3){
    // 无年份的链接重定向到对应有年份的路径
    next({
      path: `/${global.year}${to.path}`,
      query: {
        ...to.query
      },
      replace: true
    })
  } else if(to.path.split('/')[1] && to.path.split('/')[1].length==4 && to.path.split('/')[1]=='2023') {
    // 当年有不止一届会议时此处设置默认显示哪届
    let next_year = to.path.split('/')[1];
    let next_session = {'2023':'2023sh'}[next_year.toString()];
    next({
      path: `${to.path.split(next_year)[0]}${next_session}${to.path.split(next_year)[1]}`,
      query: { ...to.query },
      replace: true
    })
  } else {
    // 路径正确/已完成重定向，设置浏览器标签页 title
    if (to.meta.title) {
      document.title = to.meta.title
    } else {
      // let year = to.path.split('/')[1];
      // document.title = `ZTUP ${id_arr[year].year} 峰会 ${id_arr[year].address}站`;
      document.title = `ZTUP 峰会`;
    }
    next()
  }
})

export default router